import React from 'react';
import { useState,useEffect } from 'react';
import axios from 'axios';

const apiUrl = process.env.REACT_APP_BASEURL;

function ShippingBlock (props){

const [defaultMethod, setDefaultMethod] = useState(null);
const [defaultTerms, setDefaultTerms] = useState(null);

const getDefaultMethod = () => {
    try {
      axios.get(apiUrl + `/api/Users/GetDefaultShippingMethod`,{
        headers: {
          "Accept": "application/json",
          "Content-Type": "application/json",
          'Authorization': 'Bearer ' + props.token.token},
        })
        .then((response) => {
          // console.log("Shipping Block Line 22 defaultMethod:", response.data)
            setDefaultMethod({shipmthd: response.data});
            props.setShippingMethod(response.data);
          })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  }

const getShippingMethods = () => {
    try {
      axios.get(apiUrl + `/api/Shipping/GetShippingMethods`,{
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json",
            'Authorization': 'Bearer ' + props.token.token},
    })
        .then((response) => {
          if (!Array.isArray(response.data)) {
            setShippingMethods([response.data]);
          } else {
            setShippingMethods(response.data);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  }

  const getDefaultPaymentTerms = () => {
    try {
      axios.get(apiUrl + `/api/Users/GetDefaultPaymentTerms`,{
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json",
            'Authorization': 'Bearer ' + props.token.token},
    })
        .then((response) => {
          // console.log("get payment terms data:", response.data);
            setDefaultTerms(response.data);
            props.setPaymentMethod(response.data);
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
    // console.log("Default Terms: ", defaultTerms);
  }



let headers = new Headers({
    "Accept": "application/json",
    "Content-Type": "application/json",
    'Authorization': 'Bearer ' + props.token.token
});

const [paymentTerms, setPaymentTerms] = useState([{ pymtrmid: "QUOTE ONLY" }]);

const handleShippingChange =(event)=> {
    // console.log('Shipping method ' + JSON.stringify(event.target.value));
    props.setShippingMethod(event.target.value);
    setDefaultMethod(event.target.value);        
 }      

 const handleTermsChange =(event)=> {
  // console.log('Selected Payment Term ' + JSON.stringify(event.target.value));
  props.setPaymentMethod(event.target.value);     
}  

const [shippingMethods, setShippingMethods] = useState();

const updateInputValue =(evt)=> {
    // console.log("PO Changed");
    props.setCustomerPO(evt.target.value);
}


useEffect(() => {
  getShippingMethods();
  getDefaultMethod();
  getDefaultPaymentTerms();
  
  }, []);
  
  useEffect(() => {
    if(defaultTerms){
    setPaymentTerms([{ pymtrmid: defaultTerms}, { pymtrmid: "QUOTE ONLY" }]);
    props.setPaymentMethod(defaultTerms);
    }else{setPaymentTerms([])}
  }, [defaultTerms]);



      const renderShipMethods = () =>{
      if(shippingMethods){
            return(
              <select id="comboMethod" 
              onChange={(event) => handleShippingChange(event)} defaultValue={defaultMethod ? defaultMethod.shipmthd :"Select Shipping Method"} >
              {shippingMethods.map((method) => (<option key={method.shipmthd} value={method.shipmthd}>{method.shipmthd}</option> ))}
              </select>             
            )
        }
      };

      const renderPaymentTerms = () =>{
      return(
        <select id="comboMethod2" 
        defaultValue={defaultTerms === null ? "Select Payment": defaultTerms}
        onChange={(event) => handleTermsChange(event)} >
        {paymentTerms.map((terms) => { return <option key={terms.pymtrmid} value={terms.pymtrmid}>{terms.pymtrmid}</option> })}
        </select>   
        )
      };

      const renderCustomerPO = () =>{
      if(props.paymentMethod === "QUOTE ONLY") {
        return(<h1>You Are Requesting A Quote</h1>)
      }else{
          return(
            <>
            <h1>Customer PO #</h1>
            <input type="text" className='lg:w-[9rem]' value={props.customerPO} onChange={evt => updateInputValue(evt)} />
            </>
          )
        }
      }


        return (
            <aside id="" className="block col-1 ">
                <div className='flex'>
                <div className="flex-col mr-[1rem]">
                <h1>Shipping</h1>
                {renderShipMethods()}
                </div>
                <div className="flex-col ">
                <h1>Carrier</h1>
                {renderShipMethods()}
                </div>
                </div>
                {/* <div>
                    <br />
                    <h1>Payment Terms</h1>
                  {renderPaymentTerms()}          
                </div> */}
                <div className='flex'>
                <div className='flex-row'>
                <div className='flex-col mr-6'>
                <div className='mt-6 font-bold'>
                   Payment Terms
                </div>
                <div className='bg-white mt-1'>
                    2% 10/Net 30
                </div>
                </div>
                <div className='ml-[1rem] w-[13rem] '>
                    <br />
                {renderCustomerPO()}
                </div>
                </div>
                </div>
            </aside>
        );
}
export default ShippingBlock;